const CACHE_KEY = "minMaxpremiumLocValidationCache";
const CACHE_TTL_MS = 60 * 60 * 1000; 
const PREMIUM_LOC_BATCH_SIZE = 5; 

function buildCacheKey(state, classCode, zip, ft, pt, payroll, dateFrom) {
  return `${state.toLowerCase()}#${classCode.toLowerCase()}#${zip}#${ft.trim()}#${pt.trim()}#${payroll}#${dateFrom || "null"}`;
}

function loadCache() {
  try {
    return JSON.parse(sessionStorage.getItem(CACHE_KEY) || "{}");
  } catch {
    return {};
  }
}

function saveCache(cache) {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache));
  } catch {}
}

function isCacheEntryFresh(entry) {
  if (!entry || typeof entry.cachedAt !== "number") return false;
  return Date.now() - entry.cachedAt < CACHE_TTL_MS;
}

function purgeExpiredEntries(cache) {
  let changed = false;
  for (const key in cache) {
    if (!isCacheEntryFresh(cache[key])) {
      delete cache[key];
      changed = true;
    }
  }
  if (changed) saveCache(cache);
  return cache;
}
export function buildPremiumLocPayload(childrenLoc, effectiveDate, monoStates, moment) {
  let cache = loadCache();
  cache = purgeExpiredEntries(cache);

  const resolvedChildrenLoc = JSON.parse(JSON.stringify(childrenLoc));

  const dateFrom =
    effectiveDate?.value && moment(effectiveDate.value).isValid()
      ? moment(effectiveDate.value).format("YYYY-MM-DD")
      : null;
  const groupMap = {};

  for (const stateId in childrenLoc) {
    const locationInfo = childrenLoc[stateId];
    const state = locationInfo?.state?.value?.toLowerCase();
    const zip = locationInfo?.zipCode?.value;
    if (!state || !zip || monoStates.includes(state)) continue;

    const classCodesInfo = locationInfo.classCodesInfo || {};

    for (const classCodeId in classCodesInfo) {
      const classCodeInfo = classCodesInfo[classCodeId];
      const classCodeDesc = classCodeInfo?.classCodeDescription;
      const ft = classCodeInfo?.ft;
      const pt = classCodeInfo?.pt;
      const payroll = classCodeInfo?.payroll;
      if (!classCodeDesc?.value || !ft?.value || !pt?.value || !payroll?.value) continue;

      const classCode = classCodeDesc.value.split(":")[0]?.trim();

      let payrollVal = "";
      try {
        if (payroll.value.includes("$") && payroll.value.split("$")?.[1]) {
          payrollVal = payroll.value.split("$")[1].split(",").join("");
        } else {
          payrollVal = payroll.value.split(",").join("");
        }
      } catch (error) {
        payrollVal = payroll.value.replace(/[^0-9.]/g, "");
      }

      const cacheKey = buildCacheKey(state, classCode, zip, ft.value, pt.value, payrollVal, dateFrom);
      const cached = cache[cacheKey];

      if (cached && isCacheEntryFresh(cached)) {
        resolvedChildrenLoc[stateId].classCodesInfo[classCodeId].classCodeDescription.error =
          cached.error;
      } else {
        const groupKey = `${state}#${zip}#${dateFrom || "null"}`;
        if (!groupMap[groupKey]) {
          groupMap[groupKey] = { state, location: zip, dateFrom, entries: [] };
        }
        groupMap[groupKey].entries.push({
          stateId,
          classCodeId,
          cacheKey,
          employeeData: {
            code: classCode,
            pt: pt.value.trim(),
            ft: ft.value.trim(),
            payroll: payrollVal,
          },
        });
      }
    }
  }
  const uncachedRequests = [];

  for (const groupKey in groupMap) {
    const group = groupMap[groupKey];
    for (let i = 0; i < group.entries.length; i += PREMIUM_LOC_BATCH_SIZE) {
      const batchEntries = group.entries.slice(i, i + PREMIUM_LOC_BATCH_SIZE);

      uncachedRequests.push({
        entries: batchEntries.map(({ stateId, classCodeId, cacheKey }) => ({
          stateId,
          classCodeId,
          cacheKey,
        })),
        bodyData: {
          employees: batchEntries.map(({ stateId, classCodeId, employeeData }) => ({
            ...employeeData,
            _reqKey: `${stateId}|${classCodeId}`,
          })),
          state: group.state,
          date_from: group.dateFrom,
          location: group.location,
        },
      });
    }
  }

  return { uncachedRequests, resolvedChildrenLoc };
}
export function cachePremiumLocResult(cacheKey, isEligible) {
  const cache = loadCache();
  cache[cacheKey] = {
    error: !isEligible,
    cachedAt: Date.now(),
  };
  saveCache(cache);
}

export function chunkArray(array, size) {
  const chunks = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
}
